import { __assign } from "tslib";
import React from 'react';
import { SvgIcon } from './internal/SvgIcon';
export var Refresh2 = function Refresh2(props) {
  return React.createElement(SvgIcon, __assign({}, props), React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    d: "M12.3911 12.0888L14.0015 13.0186V8.00252L9.65741 10.5106L10.8642 11.2073C10.1037 11.8869 9.10009 12.3 7.99998 12.3C5.96945 12.3 4.26765 10.8926 3.81688 9.00005L2.08295 9.00007C2.55905 11.8377 5.027 14 7.99998 14C9.73371 14 11.2957 13.2647 12.3911 12.0888Z"
  }), React.createElement("path", {
    d: "M7.99998 3.7C10.0316 3.7 11.7341 5.10888 12.1838 7.0029L13.9175 7.00288C13.4426 4.16375 10.974 2 7.99998 2C6.26605 2 4.70392 2.7355 3.60853 3.91154L2.00275 2.98444L2.00275 8.00054L6.34682 5.49249L5.13538 4.79306C5.89588 4.11327 6.89967 3.7 7.99998 3.7Z"
  })));
};